export const LOCATION_DWELL = 'location-dwell';
